module.exports = __webpack_public_path__ + "img/v3@2x.d7e4739f.png";